module.exports = __webpack_public_path__ + "static/img/lottery-null-data.2414479d.png";